export default __webpack_public_path__ + "static/media/trump.a99960a0.png";